import { useAppSelector } from "store/store";
import { PaddingBottom } from "../Paddings/PaddingBottom/PaddingBottom";
import { PaddingTop } from "../Paddings/PaddingTop/PaddingTop";
import { TextBoxes } from "../TextBoxes/TextBoxes";
import { useMemeEditor } from "../../MemeEditorContext";
import { Icons } from "./Icons/Icons";
import { PreviewContentContainer } from "../../Containers/PreviewContentContainer/PreviewContentContainer";
import { ItemsContainer } from "../../Containers/ItemsContainer/ItemsContainer";

export const PreviewContent = () => {
    const settings = useAppSelector((state) => state.memeGenerator.meme?.settings);
    const template = useAppSelector((state) => state.memeGenerator.meme?.template);
    const { itemsContainerRef } = useMemeEditor();
    if (!settings || !template) return null;
    return (
        <PreviewContentContainer itemsContainerSettings={settings.itemsContainer} itemsContainerRef={itemsContainerRef}>
            <PaddingTop />
            <ItemsContainer settings={settings} template={template}>
                <TextBoxes />
                <Icons />
            </ItemsContainer>
            <PaddingBottom />
        </PreviewContentContainer>
    );
};
